/* eslint-disable import/prefer-default-export */
export const KEYBOARD_KEY = {
  left: 'ArrowLeft',
  right: 'ArrowRight',
  backspace: 'Backspace',
  home: 'Home',
  end: 'End'
};